import React, { useState } from "react";
import { Box, Grid, Icon, styled, Typography } from "@mui/material";
import CardData from "../../shared/dashboard/CardData";
import Utils from "../../../../utils";
import ChartAreaCustom from "../../shared/dashboard/ChartArea";
import ChartDonutCustom from "../../shared/dashboard/ChartDonut";
import dayjs from "dayjs";
import CardDashboard from "../../shared/dashboard/CardDashboard";
import { useSelector } from "react-redux";

const StyledRoot = styled(Box)({
  
})

const CostPanel = (props) => {

  const { month, year, realEmployee, realOT, empLoading } = props;

  const {result: dashboardCost} = useSelector(state => state.dashboardCost);

  const cost = dashboardCost.costData;
  const fmt = (v) => (cost ? Utils.numberWithCommas(v || 0) : "***");
  const costEmpty = !!cost && !cost.totalNet && !cost.totalSalary && !cost.totalOT;
  const [level, setLevel] = useState("department");
  const breakdownByLevel = {
    department: { label: "แผนก", data: dashboardCost.costByDepartment || [] },
    section: { label: "ส่วน", data: dashboardCost.costBySection || [] },
    division: { label: "ฝ่าย", data: dashboardCost.costByDivision || [] },
  };
  const breakdown = (breakdownByLevel[level] || breakdownByLevel.department).data;
  const breakdownLabel = (breakdownByLevel[level] || breakdownByLevel.department).label;
  const costComposition = cost
    ? [
        { name: "เงินเดือน", value: Number(cost.totalSalary) || 0 },
        { name: "ค่าล่วงเวลา", value: Number(cost.totalOT) || 0 },
        { name: "เงินเพิ่ม", value: Number(cost.totalAddition) || 0 },
        { name: "กะ", value: Number(cost.totalShift) || 0 },
      ].filter((r) => r.value > 0)
    : [];

  return (
    <StyledRoot>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={{ color: "#637381", fontSize: 14, marginBottom: "8px" }}>
            ยอดจ่ายสุทธิ = เงินเดือน + ค่าล่วงเวลา + เงินเพิ่ม − เงินหักรวม
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={4}>
              <CardData
                title="พนักงาน"
                loading={empLoading && !realEmployee}
                dataValue={Utils.numberWithCommasWithoutDot(realEmployee ? realEmployee.employeeTotal : dashboardCost.employeeTotal)}
                dataUnit="คน"
                dynamicFontSize
                titleIcon={<Icon baseClassName="fal" className="fa-users" color="primary" style={{display: "inline-table" }}/>}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <CardData
                title="เงินเดือน"
                dataValue={dashboardCost.salaryTotal === null ? "***" : fmt(cost && cost.totalSalary)}
                dataUnit="บาท"
                dynamicFontSize
                titleIcon={<Icon className="fal fa-sack-dollar" color="warning" style={{display: "inline-table", color: "#ffcd38"}}/>}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <CardData
                title="ค่าล่วงเวลา"
                dataValue={dashboardCost.salaryTotal === null ? "***" : fmt(cost && cost.totalOT)}
                dataUnit="บาท"
                dynamicFontSize
                titleIcon={<Icon className="fal fa-hand-holding-usd" color="warning" style={{display: "inline-table", color: "#ffcd38"}}/>}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <CardData
                title="เงินเพิ่ม"
                dataValue={dashboardCost.salaryTotal === null ? "***" : fmt(cost && cost.totalAddition)}
                dataUnit="บาท"
                dynamicFontSize
                titleIcon={<Icon className="fal fa-plus-circle" color="primary" style={{display: "inline-table"}}/>}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <CardData
                title="เงินหักรวม"
                dataValue={dashboardCost.salaryTotal === null ? "***" : fmt(cost && cost.totalDeductionAll)}
                dataUnit="บาท"
                dynamicFontSize
                titleIcon={<Icon className="fal fa-circle-minus" color="error" style={{display: "inline-table"}}/>}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <CardData
                title="ยอดจ่ายสุทธิ"
                dataValue={dashboardCost.salaryTotal === null ? "***" : fmt(cost && cost.totalNet)}
                dataUnit="บาท"
                dynamicFontSize
                titleIcon={<Icon className="fal fa-money-check-dollar" color="warning" style={{display: "inline-table", color: "#ffcd38"}}/>}
              />
            </Grid>
          </Grid>
        </Grid>

        {dashboardCost.costData !== undefined && (
          <Grid item xs={12}>
            {costEmpty ? (
              <Box sx={{ textAlign: "center", padding: "32px 16px", color: "#919eab", border: "1px dashed #d9d9d9", borderRadius: "12px" }}>
                <Typography sx={{ fontSize: 16 }}>ยังไม่มี payroll ที่ปิดงวดสำหรับช่วงเวลานี้</Typography>
                <Typography sx={{ fontSize: 13, marginTop: "4px" }}>(ต้องปิดงวดเงินเดือนก่อน ข้อมูลต้นทุนจ่ายจริงจึงจะแสดง)</Typography>
              </Box>
            ) : (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography sx={{ color: "#637381", fontSize: 14 }}>รายละเอียดการหัก / เงินสมทบ (ปิดรอบ pay-runs)</Typography>
              </Grid>
              <Grid item xs={6} sm={4}>
                <CardData title="ประกันสังคม" dataValue={fmt(cost && cost.totalSSO)} dataUnit="บาท" dynamicFontSize
                  titleIcon={<Icon className="fal fa-shield-halved" color="primary" style={{display:"inline-table"}}/>} />
              </Grid>
              <Grid item xs={6} sm={4}>
                <CardData title="ภาษี" dataValue={fmt(cost && cost.totalTax)} dataUnit="บาท" dynamicFontSize
                  titleIcon={<Icon className="fal fa-file-invoice-dollar" color="primary" style={{display:"inline-table"}}/>} />
              </Grid>
              <Grid item xs={6} sm={4}>
                <CardData title="หักขาด/สาย" dataValue={fmt(cost && cost.totalDeduction)} dataUnit="บาท" dynamicFontSize
                  titleIcon={<Icon className="fal fa-circle-minus" color="error" style={{display:"inline-table"}}/>} />
              </Grid>
              <Grid item xs={6} sm={6}>
                <CardData title="กองทุนสำรองฯ (พนักงาน)" dataValue={fmt(cost && cost.totalUserPF)} dataUnit="บาท" dynamicFontSize
                  titleIcon={<Icon className="fal fa-piggy-bank" color="primary" style={{display:"inline-table"}}/>} />
              </Grid>
              <Grid item xs={6} sm={6}>
                <CardData title="กองทุนสำรองฯ (บริษัทสมทบ)" dataValue={fmt(cost && cost.totalCompanyPF)} dataUnit="บาท" dynamicFontSize
                  titleIcon={<Icon className="fal fa-building-columns" color="primary" style={{display:"inline-table"}}/>} />
              </Grid>
            </Grid>
            )}
          </Grid>
        )}

        {dashboardCost.costData !== undefined && !costEmpty && (
          <Grid item xs={12} lg={5}>
            <CardDashboard>
              <Typography marginBottom="16px">องค์ประกอบเงินได้ (จ่ายจริง)</Typography>
              <ChartDonutCustom
                series={costComposition.map((r) => r.value)}
                labels={costComposition.map((r) => r.name)}
              />
            </CardDashboard>
          </Grid>
        )}

        {dashboardCost.costData !== undefined && !costEmpty && (dashboardCost.costDataAllYear || []).length > 0 && (
          <Grid item xs={12} lg={7}>
            <CardDashboard>
              <Typography marginBottom="16px">ยอดจ่ายสุทธิจริง (รายปี {year})</Typography>
              <ChartAreaCustom
                series={[{ name: "จ่ายจริง", data: (dashboardCost.costDataAllYear || []).map(s => ({x: dayjs().month(s.month-1).format("MMM"), y: s.totalNet})) }]}
              />
            </CardDashboard>
          </Grid>
        )}

        {dashboardCost.costData !== undefined && !costEmpty && breakdown.length > 0 && (
          <Grid item xs={12}>
            <CardDashboard>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px", marginBottom: "16px" }}>
                <Typography>ต้นทุนจ่ายจริงแยกตาม{breakdownLabel} — Top 10 (จาก {breakdown.length} {breakdownLabel})</Typography>
                <Box sx={{ display: "flex", gap: "6px" }}>
                  {["department", "section", "division"].map((lv) => (
                    <Box key={lv} onClick={() => setLevel(lv)}
                      sx={{ cursor: "pointer", padding: "4px 14px", borderRadius: "8px", fontSize: 14,
                        backgroundColor: level === lv ? "#007afe" : "#f0f1f3", color: level === lv ? "#fff" : "#666" }}>
                      {breakdownByLevel[lv].label}
                    </Box>
                  ))}
                </Box>
              </Box>
              <Box>
                <Box sx={{ display: "flex", padding: "8px 12px", color: "#919eab", fontSize: 13, borderBottom: "1px solid #ececec" }}>
                  <Box sx={{ width: 28 }}>#</Box>
                  <Box sx={{ flexGrow: 1 }}>{breakdownLabel}</Box>
                  <Box sx={{ width: 70, textAlign: "right" }}>คน</Box>
                  <Box sx={{ width: 140, textAlign: "right" }}>จ่ายจริง (บาท)</Box>
                  <Box sx={{ width: 120, textAlign: "right" }}>เฉลี่ย/คน</Box>
                </Box>
                {breakdown.slice(0, 10).map((d, i) => (
                  <Box key={i} sx={{ display: "flex", alignItems: "center", padding: "10px 12px", borderBottom: "1px solid #f5f5f5" }}>
                    <Box sx={{ width: 28, fontWeight: 700, color: i <= 2 ? "#007afe" : "#919eab" }}>{i + 1}</Box>
                    <Typography sx={{ flexGrow: 1 }}>{d.name}</Typography>
                    <Typography sx={{ width: 70, textAlign: "right" }}>{Utils.numberWithCommasWithoutDot(d.employeeCount)}</Typography>
                    <Typography sx={{ width: 140, textAlign: "right", fontWeight: 700 }}>{Utils.numberWithCommas(d.totalNet)}</Typography>
                    <Typography sx={{ width: 120, textAlign: "right", color: "#919eab" }}>{Utils.numberWithCommas(d.netPerPerson)}</Typography>
                  </Box>
                ))}
              </Box>
            </CardDashboard>
          </Grid>
        )}

        {/* <Grid item xs={12}>
          <CardDashboard>
            <Typography marginBottom="16px">รายจ่ายเงินเดือน (รายปี {year})</Typography>
            <ChartAreaCustom
              series={[
                {
                  name: "รายจ่าย",
                  data: dashboardCost.salaryTotalAllYear.map(s => {return {x: dayjs().month(s.month-1).format("MMM"), y: s.salaryTotal}})
                }
              ]}
            />
          </CardDashboard>
        </Grid> */}

        {/* <Grid item xs={12}>
          <CardDashboard>
            <Typography marginBottom="16px">รายจ่ายค่าล่วงเวลา (รายปี {year})</Typography>
            <ChartAreaCustom
              series={[
                {
                  name: "รายจ่าย",
                  data: dashboardCost.otTotalAllYear.map(s => {return {x: dayjs().month(s.month-1).format("MMM"), y: s.payTotal}})
                }
              ]}
            />
          </CardDashboard>
        </Grid> */}
      </Grid>
    </StyledRoot>
  )
}

export default CostPanel;